import React, { Component } from 'react'
import { Button } from '@progress/kendo-react-buttons'
const moment = require('moment');


class RotuloLink extends Component {
    render() {
        const rotuloRes = this.props.rotuloRes
        const character = rotuloRes["características_do_rotulo"]
        const resume = rotuloRes["resumo_do_registo"][0]
        return (
            <div className="modal-content graphicas-rotulo-link">
                <div className="modal-header">
                    <span className="modal-title bold" style={{fontSize:"large"}}>
                        <b>Detalhe do pedido</b>
                    </span>
                    <div className="buttons">
                        <Button className="remove k-primary btn-ivdp-primary cursor-pointer mr-2">Ficha Resumo Rótulo</Button>
                        <Button className="mr-2 k-primary btn-ivdp-secondary btn-theme remove ml-2 text-danger" onClick={() => this.props.activateLink()}>Fechar</Button>
                    </div>
                </div>
                <div className="modal-body">
                    <div className="container ml-3 mt-3">
                        <h3>Resumo do registo</h3>
                        <div className="group my-3">
                            <p><strong>Nº Registo</strong></p>
                            <p>{this.props.nPedido}</p>
                        </div>
                        <div className="group my-3">
                            <p><strong>Produto</strong></p>
                            <p>{resume["produto"] ? resume["produto"] : "nd"}</p>
                        </div>
                        <div className="d-flex justify-content-between" style={{marginRight:"200px"}}>
                            <div className="group my-3 w-25">
                                <p><strong>Cor</strong></p>
                                <p>{resume["cor"] ? resume["cor"] : "nd"}</p>
                            </div>
                            <div className="group my-3 w-25">
                                <p><strong>Álcool</strong></p>
                                <p>{resume["alcool"] ? resume["alcool"] : "nd"}</p>
                            </div>
                            <div className="group my-3 w-25">
                                <p><strong>Tipo</strong></p>
                                <p>{this.props.tipo}</p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between" style={{marginRight:"200px"}}>
                            <div className="group my-3 w-25">
                                <p><strong>Ano</strong></p>
                                <p>{resume["ano"] ? resume["ano"] : "nd"}</p>
                            </div>
                            <div className="group my-3 w-25">
                                <p><strong>Doçura</strong></p>
                                <p>{resume["docura"] ? resume["docura"] : "nd"}</p>
                            </div>
                            <div className="group my-3 w-25">
                                <p><strong>Acidez</strong></p>
                                <p>{resume["acidez"] ? resume["acidez"] : "nd"}</p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between" style={{marginRight:"200px"}}>
                            <div className="group my-3 w-25">
                                <p><strong>Saldo inicial (Lts)</strong></p>
                                <p>{resume["saldoinitial"] ? resume["saldoinitial"] : "nd"}</p>
                            </div>
                            <div className="group my-3 w-25">
                                <p><strong>Madeira</strong></p>
                                <p>S/N</p>
                            </div>
                            <div className="group my-3 w-25">
                                <p><strong></strong></p>
                                <p></p>
                            </div>
                        </div>
                        <div className="mt-5">
                            <h3>Características do rótulo</h3>
                        </div>
                        <div className="group my-3">
                            <p><strong>Nome da Marca</strong></p>
                            <p>{character["namedamacra"] ? character["namedamacra"] : "nd"}</p>
                        </div>
                        <div className="d-flex justify-content-between" style={{marginRight:"200px"}}>
                            <div className="group my-3 w-25">
                                <p><strong>Ano</strong></p>
                                <p>{character["ano"] ? character["ano"] : "nd"}</p>
                            </div>
                            <div className="group my-3 w-25">
                                <p><strong>Cor</strong></p>
                                <p>{character["cor"] ? character["cor"] : "nd"}</p>
                            </div>
                            <div className="group my-3 w-25">
                                <p><strong>Álcool</strong></p>
                                <p>{character["alcool"] ? character["alcool"] : "nd"}</p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between" style={{marginRight:"200px"}}>
                            <div className="group my-3 w-25">
                                <p><strong>Capacidade nominal</strong></p>
                                <p>{character["capasidadenominal"] ? character["capasidadenominal"] : "nd"}</p>
                            </div>
                            <div className="group my-3 w-25">
                                <p><strong>Doçura</strong></p>
                                <p>{character["docura"] ? character["docura"] : "nd"}</p>
                            </div>
                            <div className="group my-3 w-25">
                                <p><strong></strong></p>
                                <p></p>
                            </div>
                        </div>

                        <div className="mt-5">
                            <h3>Processamento</h3>
                        </div>
                        <div className="my-3">
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex, tempora voluptate, eligendi voluptatem modi perspiciatis, magnam repellendus commodi ratione quae minima quaerat animi sapiente esse possimus aperiam voluptates quibusdam! Alias magnam ab assumenda dolor, quos dolorem perferendis accusantium, corrupti nihil sunt a ut numquam ducimus maiores eos quaerat aperiam eius temporibus vero animi! Dolores vitae voluptates sequi explicabo voluptate harum quibusdam ea, veniam, voluptatum laudantium dolor voluptas minus mollitia quod earum odio nesciunt consequuntur repellendus aliquid eius. Magnam, assumenda inventore.</p>
                        </div>
                        <div className="d-flex justify-content-between" style={{marginRight:"200px"}}>
                            <div className="group my-3 w-25">
                                <p><strong>Data de submissão de pedido</strong></p>
                                <p>{rotuloRes['datadesubmissaodependido'] ? moment(rotuloRes['datadesubmissaodependido']).format("YYYY-MM-DD") : 'nd'}</p>
                            </div>
                            <div className="group my-3 w-25">
                                <p><strong></strong></p>
                                <p></p>
                            </div>
                            <div className="group my-3 w-25">
                                <p><strong>Data de 1ª avaliação</strong></p>
                                <p>{rotuloRes['datade1availicao'] ? moment(rotuloRes['datade1availicao']).format("YYYY-MM-DD") : 'nd'}</p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between" style={{marginRight:"200px"}}>
                            <div className="group my-3 w-25">
                                <p><strong>Data de 2ª avaliação</strong></p>
                                <p>{rotuloRes['datade2availicao'] ? moment(rotuloRes['datade2availicao']).format("YYYY-MM-DD") : 'nd'}</p>
                            </div>
                            <div className="group my-3 w-25">
                                <p><strong></strong></p>
                                <p></p>
                            </div>
                            <div className="group my-3 w-25">
                                <p><strong>Data de finalização</strong></p>
                                <p>{rotuloRes['datadefinalizaco'] ? moment(rotuloRes['datadefinalizaco']).format("YYYY-MM-DD") : 'nd'}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                
            
        )
    }
}
export default RotuloLink